<template>
  <el-drawer
    title="New task..."
    v-model="isCreateModal"
    direction="btt"
    class="createTask"
    size="100%"
    @open="loadStationList"
  >
    <el-form
      ref="ruleFormRef"
      :model="form"
      :rules="rules"
      label-width="120px"
      status-icon
      label-position="top"
    >
      <el-form-item label="Title" prop="title">
        <el-input v-model="form.title" />
      </el-form-item>

      <el-form-item label="Station" prop="stationId">
        <el-select
          v-model="form.stationId"
          filterable
          placeholder="Select station"
        >
          <el-option
            v-for="item in stationList"
            :key="item.id"
            :label="item.locationName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Date" prop="mustDone">
        <el-date-picker
          v-model="form.mustDone"
          type="date"
          format="YY/MM/DD"
          :picker-options="pickerOptions"
          placeholder="Pick a deadline"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="Text" prop="text">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="Describe your task"
          v-model="form.text"
        >
        </el-input>
      </el-form-item>

      <el-button
        type="success"
        @click="submitForm('ruleFormRef')"
        :loading="loading"
      >
        Save
      </el-button>
    </el-form>
  </el-drawer>
</template>


<script>
import ApiTask from "@/api/task";
import TaskMixin from "@/mixins/Task.mixins";

import _ from "lodash";
export default {
  computed: {
    isCreateModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      copyTaskList: [],
      stationList: [],
      stationListLoaded: false,
      loading: false,
      form: {
        categoryId: 3,
        status: "active",
      },
      rules: {
        title: [
          { required: true, message: "Please input title", trigger: "blur" },
        ],
        stationId: [
          { required: true, message: "Please choose station", trigger: "blur" },
        ],
        text: [
          { required: true, message: "Please input text", trigger: "blur" },
        ],
        mustDone: [
          { required: true, message: "Please choose date", trigger: "blur" },
        ],
      },
    };
  },
  mixins: [TaskMixin],
  methods: {
    loadStationList() {
      if (this.stationListLoaded) {
        return;
      }
      ApiTask.getStationList().then((responce) => {
        this.stationList = responce.data;
        this.stationListLoaded = true;
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.mustDone = Math.floor(
            new Date(this.form.mustDone).getTime() / 1000
          );
          // console.log(this.form.mustDone);
          // return;
          console.log(this.form);
          ApiTask.create(this.form).then((responce) => {
            if (!responce.status) {
              this.$message({
                message: "Something wrong",
                type: "danger",
              });
            } else {
              this.$message({
                message: "The task was create",
                type: "success",
              });
              this.$refs[formName].resetFields();
              this.$emit("close");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
